// extracted by mini-css-extract-plugin
module.exports = {"topNRecordsLineGraph":"LineOutGraphs_topNRecordsLineGraph__ahW6H","heading":"LineOutGraphs_heading__1zy3a","innerGraphContainer":"LineOutGraphs_innerGraphContainer__3AZPb"};